import {
  Type,
  ImagePlus,
  Brush,
} from 'lucide-react';
import type { GenerationModeOption, AspectRatioOption, QualityOption } from './types';

export const ASPECT_RATIOS: AspectRatioOption[] = [
  { label: '自动', value: 'auto', apiValue: 'auto', description: '智能适配' },
  { label: '1:1', value: '1:1', apiValue: '1024x1024', description: '方图/头像' },
  { label: '4:3', value: '4:3', apiValue: '1024x768', description: '电脑横屏/PPT' },
  { label: '3:4', value: '3:4', apiValue: '768x1024', description: '手机竖屏/海报' },
  { label: '3:2', value: '3:2', apiValue: '1536x1024', description: '相机照片/风景' },
  { label: '2:3', value: '2:3', apiValue: '1024x1536', description: '竖版照片/人像' },
  { label: '16:9', value: '16:9', apiValue: '2048x1152', description: '壁纸/横版封面' },
  { label: '9:16', value: '9:16', apiValue: '1152x2048', description: '短视频/竖版封面' },
  { label: '4:5', value: '4:5', apiValue: '1024x1280', description: '社媒帖子/商品图' },
  { label: '5:4', value: '5:4', apiValue: '1280x1024', description: '印刷照片/展示图' },
  { label: '2:1', value: '2:1', apiValue: '2048x1024', description: '横幅/封面图' },
  { label: '1:2', value: '1:2', apiValue: '1024x2048', description: '竖幅/长图' },
  { label: '3:1', value: '3:1', apiValue: '1881x836', description: '超宽横幅/广告图' },
  { label: '1:3', value: '1:3', apiValue: '887x1774', description: '超长竖图/海报' },
  { label: '21:9', value: '21:9', apiValue: '2560x1024', description: '超宽屏/电影感' },
  { label: '9:21', value: '9:21', apiValue: '1024x2560', description: '手机长图/全屏图' },
];

// quality 值直接使用 API 值: low (1K), medium (2K), high (4K)
export const QUALITY_OPTIONS: QualityOption[] = [
  { label: '标准 1K', value: 'low', apiValue: 'low', credits: 1 },
  { label: '高清 2K', value: 'medium', apiValue: 'medium', credits: 2 },
  { label: '超清 4K', value: 'high', apiValue: 'high', credits: 3 },
];

export const GENERATION_MODES: GenerationModeOption[] = [
  { id: 'text2img', label: '文生图', icon: Type, description: '用文字描述生成图片' },
  { id: 'img2img', label: '参考图生图', icon: ImagePlus, description: '基于参考图生成新图片' },
  { id: 'inpaint', label: '局部重绘', icon: Brush, description: '涂抹区域进行重绘' },
];
